import { getRoute } from '@/app/core/api/routes';
import { SubscriptionInterface } from '@/app/features/subscription/interfaces';

import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { ResponseInterface } from '@/app/shared/interfaces/response.interface';
import { CurrentSubscriptionInterface } from '@/app/features/subscription/interfaces/current-subscription.interface';
import { GetCheckoutUrlPayloadInterface } from '@/app/features/subscription/interfaces/get-checkout-url-payload.interface';

@Injectable({
  providedIn: 'root',
})
export class SubscriptionApiService {
  constructor(private http: HttpClient) {}

  loadCurrentPlan() {
    const action = getRoute('plans.current-plan');

    return this.http.get<ResponseInterface<CurrentSubscriptionInterface>>(action);
  }

  loadAvailablePlans() {
    const action = getRoute('plans.available-plans');

    return this.http.get<ResponseInterface<SubscriptionInterface[]>>(action);
  }

  cancelSubscription(plan: CurrentSubscriptionInterface) {
    const action = getRoute('plans.subscription.cancel');

    return this.http.put<ResponseInterface<CurrentSubscriptionInterface>>(action, null);
  }

  renewSubscription(plan: CurrentSubscriptionInterface) {
    const action = getRoute('plans.subscription.renew');

    return this.http.put<ResponseInterface<CurrentSubscriptionInterface>>(action, null);
  }

  updateSubscription(plan: SubscriptionInterface | null = null) {
    const action = getRoute('plans.current-plan');

    return this.http.put<ResponseInterface<CurrentSubscriptionInterface>>(action, {
      price_id: plan?.price_id ?? null,
    });
  }

  getCheckoutUrl(payload: GetCheckoutUrlPayloadInterface) {
    const action = getRoute('plans.checkout-url');

    return this.http.get<ResponseInterface<{ url: string }>>(action, {
      params: new HttpParams({
        fromObject: {
          price_id: payload.price_id,
        },
      }),
    });
  }
}
